import { render, staticRenderFns } from "./TabelaResultadosRespostas.vue?vue&type=template&id=d081b192&scoped=true&"
import script from "./TabelaResultadosRespostas.vue?vue&type=script&lang=js&"
export * from "./TabelaResultadosRespostas.vue?vue&type=script&lang=js&"
import style0 from "./TabelaResultadosRespostas.vue?vue&type=style&index=0&id=d081b192&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d081b192",
  null
  
)

export default component.exports